import clsx from 'clsx';

export const styles = clsx('flex', 'flex-col', 'gap-xl', 'mb-xl');
